// extracted by mini-css-extract-plugin
module.exports = {"link":"_e742e227","imageWrapper":"_17479dd3","image":"_ae8bd2c0","title":"_4b166fc7"};